import type { SVGProps } from 'react';

interface DateIconProps {
  title?: string;
  titleId?: string;
  desc?: string;
  descId?: string;
}
export const DateIcon = ({
  title,
  titleId,
  desc,
  descId,
  ...props
}: SVGProps<SVGSVGElement> & DateIconProps) => (
  <svg
    {...props}
    aria-labelledby={titleId}
    fill="none"
    height="1em"
    role="img"
    viewBox="0 0 16 16"
    width="1em"
    xmlns="http://www.w3.org/2000/svg"
  >
    <title id={titleId}>{title}</title>
    <g clipPath="url(#date_svg__a)">
      <path
        d="M16 5.389v8.222a2.89 2.89 0 0 1-2.889 2.889H2.89A2.89 2.89 0 0 1 0 13.611V5.39zM13.111.5A2.89 2.89 0 0 1 16 3.389v.667H0v-.667A2.89 2.89 0 0 1 2.889.5z"
        fill="currentColor"
      />
    </g>
    <defs>
      <clipPath id="date_svg__a">
        <path d="M0 0h16v16H0z" fill="#fff" />
      </clipPath>
    </defs>
  </svg>
);
